export function toHumanDate(date) {
  return date
    .split("-")
    .reverse()
    .join("/");
}

export function dayDiff(dateString) {
  var today = new Date();
  var date = new Date(dateString);

  // To calculate the time difference of two dates
  var differenceInTime = date.getTime() - today.getTime();

  // To calculate the no. of days between two dates
  return Math.floor(differenceInTime / (1000 * 3600 * 24));
}

export const emojis = [
  "😁",
  "😂",
  "😃",
  "😄",
  "😅",
  "😆",
  "😉",
  "😊",
  "😋",
  "😌",
  "😍",
  "😏",
  "😒",
  "😓",
  "😔",
  "😖",
  "😘",
  "😚",
  "😜",
  "😝",
  "😞",
  "😠",
  "😢",
  "😤",
  "😥",
  "😨",
  "😩",
  "😪",
  "😫",
  "😭",
  "😰",
  "😱",
  "😲",
  "😳",
  "😵",
  "😷",
  "😸",
  "😹",
  "😺",
  "😻",
  "😼",
  "😽",
  "😾",
  "😿",
  "🙀",
  "🙅",
  "🙆",
  "🙇",
  "🙈",
  "🙉",
  "🙊",
  "🙋",
  "🙌",
  "🙍",
  "🙎",
  "🙏"
];

export const formFields = (fields, initial = {}) => {
  const form = {};
  const errors = {};
  for (const i in fields) {
    const field = fields[i];
    form[field] = initial && initial[field] ? initial[field] : "";
    errors[field] = [];
  }
  return { form, errors, loading: false };
};

export const formatMoney = (
  amount,
  decimalCount = 2,
  decimal = ",",
  thousands = "."
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    const negativeSign = amount < 0 ? "-" : "";
    const i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    const j = i.length > 3 ? i.length % 3 : 0;
    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    return "0,00";
  }
};

export const clearObject = object => {
  const newObject = { ...object };
  for (const i in newObject) {
    if (
      newObject[i] === "" ||
      newObject[i] === undefined ||
      newObject[i] === null
    ) {
      delete newObject[i];
    }
  }
  return newObject;
};

export const breakpoints = {
  576: {
    slidesPerView: 2
  },
  768: {
    slidesPerView: 3
  },
  992: {
    slidesPerView: 4
  },
  1200: {
    slidesPerView: 5
  },
  1600: {
    slidesPerView: 6
  }
};

export const youtubeParser = url => {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
};

export const countries = [
  ["ABW", "Aruba"],
  ["AFG", "Afeganistão"],
  ["AGO", "Angola"],
  ["AIA", "Anguila"],
  ["ALA", "Ilhas Åland"],
  ["ALB", "Albânia"],
  ["AND", "Andorra"],
  ["ANT", "Antilhas Holandesas"],
  ["ARE", "Emirados Árabes Unidos"],
  ["ARG", "Argentina"],
  ["ARM", "Armênia"],
  ["ASM", "Samoa Americana"],
  ["ATA", "Antártida"],
  ["ATF", "Terras Austrais e Antárticas Francesas"],
  ["ATG", "Antígua e Barbuda"],
  ["AUS", "Austrália"],
  ["AUT", "Áustria"],
  ["AZE", "Azerbaijão"],
  ["BDI", "Burundi"],
  ["BEL", "Bélgica"],
  ["BEN", "Benim"],
  ["BFA", "Burquina Fasso"],
  ["BGD", "Bangladesh"],
  ["BGR", "Bulgária"],
  ["BHR", "Bahrein"],
  ["BHS", "Bahamas"],
  ["BIH", "Bósnia e Herzegovina"],
  ["BLM", "São Bartolomeu"],
  ["BLR", "Bielorrússia"],
  ["BLZ", "Belize"],
  ["BMU", "Bermudas"],
  ["BOL", "Bolívia"],
  ["BRA", "Brasil"],
  ["BRB", "Barbados"],
  ["BRN", "Brunei"],
  ["BTN", "Butão"],
  ["BVT", "Ilha Bouvet"],
  ["BWA", "Botswana"],
  ["CAF", "República Centro-Africana"],
  ["CAN", "Canadá"],
  ["CCK", "Ilhas Cocos (Keeling)"],
  ["CHE", "Suíça"],
  ["CHL", "Chile"],
  ["CHN", "China"],
  ["CIV", "Costa do Marfim"],
  ["CMR", "Camarões"],
  ["COD", "República Democrática do Congo"],
  ["COG", "República do Congo"],
  ["COK", "Ilhas Cook"],
  ["COL", "Colômbia"],
  ["COM", "Comores"],
  ["CPV", "Cabo Verde Cabo Verde"],
  ["CRI", "Costa Rica"],
  ["CUB", "Cuba"],
  ["CUW", "Curaçau"],
  ["CXR", "Ilha do Natal"],
  ["CYM", "Ilhas Caimã"],
  ["CYP", "Chipre"],
  ["CZE", "Chéquia"],
  ["DEU", "Alemanha"],
  ["DJI", "Djibouti"],
  ["DMA", "Dominica"],
  ["DNK", "Dinamarca"],
  ["DOM", "República Dominicana"],
  ["DZA", "Argélia"],
  ["ECU", "Equador"],
  ["EGY", "Egito"],
  ["ERI", "Eritreia"],
  ["ESH", "Saara Ocidental"],
  ["ESP", "Espanha"],
  ["EST", "Estónia"],
  ["ETH", "Etiópia"],
  ["FIN", "Finlândia"],
  ["FJI", "Fiji"],
  ["FLK", "Ilhas Malvinas"],
  ["FRA", "França"],
  ["FRO", "Ilhas Feroé"],
  ["FSM", "Estados Federados da Micronésia"],
  ["GAB", "Gabão"],
  ["GBR", "Reino Unido"],
  ["GEO", "Geórgia"],
  ["GGY", "Guernsey"],
  ["GHA", "Gana"],
  ["GIB", "Gibraltar"],
  ["GIN", "Guiné"],
  ["GLP", "Guadalupe"],
  ["GMB", "Gâmbia"],
  ["GNB", "Guiné-Bissau"],
  ["GNQ", "Guiné Equatorial"],
  ["GRC", "Grécia"],
  ["GRD", "Granada"],
  ["GRL", "Gronelândia"],
  ["GTM", "Guatemala"],
  ["GUF", "Guiana Francesa"],
  ["GUM", "Guam"],
  ["GUY", "Guiana"],
  ["HKG", "Hong Kong"],
  ["HMD", "Ilha Heard e Ilhas McDonald"],
  ["HND", "Honduras"],
  ["HRV", "Croácia"],
  ["HTI", "Haiti"],
  ["HUN", "Hungria"],
  ["IDN", "Indonésia"],
  ["IMN", "Ilha de Man"],
  ["IND", "Índia"],
  ["IOT", "Território Britânico do Oceano Índico"],
  ["IRL", "Irlanda"],
  ["IRN", "Irã Irão"],
  ["IRQ", "Iraque"],
  ["ISL", "Islândia"],
  ["ISR", "Israel"],
  ["ITA", "Itália"],
  ["JAM", "Jamaica"],
  ["JEY", "Jersey"],
  ["JOR", "Jordânia"],
  ["JPN", "Japão"],
  ["KAZ", "Cazaquistão"],
  ["KEN", "Quênia"],
  ["KGZ", "Quirguistão"],
  ["KHM", "Camboja Camboja"],
  ["KIR", "Kiribati"],
  ["KNA", "São Cristóvão e Neves"],
  ["KOR", "Coreia do Sul Coreia do Sul"],
  ["KWT", "Kuwait"],
  ["LAO", "Laos Laos"],
  ["LBN", "Líbano"],
  ["LBR", "Libéria"],
  ["LBY", "Líbia"],
  ["LCA", "Santa Lúcia"],
  ["LIE", "Liechtenstein"],
  ["LKA", "Sri Lanka"],
  ["LSO", "Lesoto"],
  ["LTU", "Lituânia"],
  ["LUX", "Luxemburgo"],
  ["LVA", "Letônia"],
  ["MAC", "Macau"],
  ["MAF", "São Martinho"],
  ["MAR", "Marrocos"],
  ["MCO", "Mónaco"],
  ["MDA", "Moldávia"],
  ["MDG", "Madagáscar"],
  ["MDV", "Maldivas"],
  ["MEX", "México"],
  ["MHL", "Ilhas Marshall"],
  ["MKD", "Macedónia do Norte Macedônia do Norte"],
  ["MLI", "Mali"],
  ["MLT", "Malta"],
  ["MMR", "Myanmar Myanmar"],
  ["MNE", "Montenegro"],
  ["MNG", "Mongólia Mongólia"],
  ["MNP", "Marianas Setentrionais"],
  ["MOZ", "Moçambique"],
  ["MRT", "Mauritânia"],
  ["MSR", "Monserrate"],
  ["MTQ", "Martinica"],
  ["MUS", "Ilhas Maurícias"],
  ["MWI", "Malawi"],
  ["MYS", "Malásia"],
  ["MYT", "Mayotte"],
  ["NAM", "Namíbia"],
  ["NCL", "Nova Caledónia"],
  ["NER", "Níger"],
  ["NFK", "Ilha Norfolk"],
  ["NGA", "Nigéria"],
  ["NIC", "Nicarágua"],
  ["NIU", "Niue"],
  ["NLD", "Países Baixos"],
  ["NOR", "Noruega"],
  ["NPL", "Nepal"],
  ["NRU", "Nauru"],
  ["NZL", "Nova Zelândia"],
  ["OMN", "Omã Omã"],
  ["PAK", "Paquistão"],
  ["PAN", "Panamá"],
  ["PCN", "Pitcairn"],
  ["PER", "Peru"],
  ["PHL", "Filipinas"],
  ["PLW", "Palau"],
  ["PNG", "Papua-Nova Guiné"],
  ["POL", "Polónia"],
  ["PRI", "Porto Rico"],
  ["PRK", "Coreia do Norte"],
  ["PRT", "Portugal Portugal"],
  ["PRY", "Paraguai"],
  ["PSE", "Palestina"],
  ["PYF", "Polinésia Francesa"],
  ["QAT", "Catar"],
  ["REU", "Reunião"],
  ["ROU", "Roménia"],
  ["RUS", "Rússia"],
  ["RWA", "Ruanda"],
  ["SAU", "Arábia Saudita"],
  ["SDN", "Sudão"],
  ["SEN", "Senegal"],
  ["SGP", "Singapura Singapura"],
  ["SGS", "Ilhas Geórgia do Sul e Sandwich do Sul"],
  ["SHN", "Santa Helena, Ascensão e Tristão da Cunha"],
  ["SJM", "Svalbard e Jan Mayen"],
  ["SLB", "Ilhas Salomão"],
  ["SLE", "Serra Leoa"],
  ["SLV", "El Salvador"],
  ["SMR", "San Marino"],
  ["SOM", "Somália"],
  ["SPM", "São Pedro e Miquelão"],
  ["SRB", "Sérvia"],
  ["STP", "São Tomé e Príncipe"],
  ["SUR", "Suriname"],
  ["SVK", "Eslováquia"],
  ["SVN", "Eslovênia"],
  ["SWE", "Suécia"],
  ["SWZ", "Essuatíni"],
  ["SYC", "Seicheles"],
  ["SYR", "Síria Síria"],
  ["TCA", "Turcas e Caicos"],
  ["TCD", "Chade"],
  ["TGO", "Togo"],
  ["THA", "Tailândia"],
  ["TJK", "Tajiquistão"],
  ["TKL", "Toquelau"],
  ["TKM", "Turquemenistão"],
  ["TLS", "Timor-Leste"],
  ["TON", "Tonga"],
  ["TTO", "Trinidad e Tobago"],
  ["TUN", "Tunísia"],
  ["TUR", "Turquia"],
  ["TUV", "Tuvalu"],
  ["TWN", "Taiwan"],
  ["TZA", "Tanzânia"],
  ["UGA", "Uganda"],
  ["UKR", "Ucrânia"],
  ["UMI", "Ilhas Menores Distantes dos Estados Unidos"],
  ["URY", "Uruguai"],
  ["USA", "Estados Unidos"],
  ["UZB", "Uzbequistão"],
  ["VAT", "Vaticano"],
  ["VCT", "São Vicente e Granadinas"],
  ["VEN", "Venezuela"],
  ["VGB", "Ilhas Virgens Britânicas"],
  ["VIR", "Ilhas Virgens Americanas"],
  ["VNM", "Vietname"],
  ["VUT", "Vanuatu"],
  ["WLF", "Wallis e Futuna"],
  ["WSM", "Samoa"],
  ["YEM", "Iêmen"],
  ["ZAF", "África do Sul"],
  ["ZMB", "Zâmbia"],
  ["ZWE", "Zimbabwe"]
];

export const states = [
  ["AC", "Acre"],
  ["AL", "Alagoas"],
  ["AP", "Amapá"],
  ["AM", "Amazonas"],
  ["BA", "Bahia"],
  ["CE", "Ceará"],
  ["DF", "Distrito Federal"],
  ["ES", "Espírito Santo"],
  ["GO", "Goías"],
  ["MA", "Maranhão"],
  ["MT", "Mato Grosso"],
  ["MS", "Mato Grosso do Sul"],
  ["MG", "Minas Gerais"],
  ["PA", "Pará"],
  ["PB", "Paraíba"],
  ["PR", "Paraná"],
  ["PE", "Pernambuco"],
  ["PI", "Piauí"],
  ["RJ", "Rio de Janeiro"],
  ["RN", "Rio Grande do Norte"],
  ["RS", "Rio Grande do Sul"],
  ["RO", "Rondônia"],
  ["RR", "Roraíma"],
  ["SC", "Santa Catarina"],
  ["SP", "São Paulo"],
  ["SE", "Sergipe"],
  ["TO", "Tocantins"]
];
